<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        size="lg"
        :show.sync="show">
        <CRow>
          <CCol>
             <CRow >

               <CCol>
                 <label> {{ "Firstname: " + form.firstname  }} </label>
               </CCol>
                 </CRow>
             <hr>
              <CRow>
                <CCol><label> {{ "Lastname: " + form.lastname }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow><CCol>
                <label> {{ "Date of Birth: " + form.dob }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow>
                <CCol>
                <label> {{ "Sex: " + form.sex }} </label>
                </CCol>
                </CRow>
                <hr>
              <CRow><CCol>
                <label> {{ "Email: " + form.email }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow><CCol>
                <label> {{ "Phone: " + form.phone }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow>
                <CCol><label> {{ "Mobile Phone: " + form.mobile_phone }} </label>
                </CCol>
                </CRow>
          </CCol>
          <CCol class="ml-5">
                <CRow>
                <CCol><label> {{ "Address 1: " + form.address1 }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow><CCol>
                <label> {{ "Address 2: " + form.address2 }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow><CCol>
                <label> {{ "City: " + form.city }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow>
                <CCol><label> {{ "State: " + form.state }} </label>
                </CCol>
                </CRow>
              <hr>
              <CRow>
                <CCol><label> {{ "Country: " + form.country }} </label>
                </CCol>
                </CRow>
              <hr>
                <CRow>
                <CCol><label> {{ "Zipcode: " + form.zipcode }} </label>
                </CCol>
                </CRow>
              <hr>

          </CCol>
        </CRow>
        <br><br>
        <CRow>
          <CCol>
              <label class="mt-3"> <b> People Movement </b> </label>
              <table class="mt-1">
                <thead>
                  <tr>
                    <th v-for="item in fields_movement" :key="item.title">
                    {{ item.title }}
                    </th>
                  </tr>
                </thead>
              <tbody>
                <tr v-for="i in form.people_movement" :key="i.id" >
                  <td>{{ i.created_at }}</td>
                  <td v-if="i.from === null">{{ "Status: " + i.to }}</td>
                  <td v-else>{{ "Status: "}}  <label> <del> {{ i.from }}</del> </label> {{" -> "}} <b> <mark>  {{ i.to }} </mark> </b> </td>
                </tr>
              </tbody>
              </table>
            </CCol>
        </CRow>
        <CRow>
          <CCol>
              <label class="mt-3"> <b> People Activity </b> - Icare Visitor Movement </label>
              <table class="mt-1">
                <thead>
                  <tr>
                    <th v-for="item in fields_movement" :key="item.title">
                    {{ item.title }}
                    </th>
                  </tr>
                </thead>
              <tbody>
                <tr v-for="i in people_activity" :key="i.id">
                  <div v-if="i.type == 'icare_visitor'">
                  <td>{{ i.created_at }}</td>
                  <td v-if="i.from_name === null">{{ "Status: " + i.to_name }}</td>
                  <td v-else>{{ "Status: "}}  <label> <del> {{ i.from_name }}</del> </label> {{" -> "}} <b> <mark>  {{ i.to_name }} </mark> </b> </td>
                  </div>
                </tr>
              </tbody>
              </table>
            </CCol>
        </CRow>
        <CRow>
          <CCol>
              <label class="mt-3"> <b> Certificates </b> </label>
              <div v-if="certificates_loading" class="text-muted">Loading certificates...</div>
              <table v-else-if="certificates.length" class="mt-1 table table-sm">
                <thead>
                  <tr><th>Number</th><th>Date</th><th>Type</th><th>Printed Name</th><th>Status</th></tr>
                </thead>
                <tbody>
                  <tr v-for="i in certificates" :key="i.uuid">
                    <td>{{ i.formatted_number }}</td>
                    <td>{{ i.document_date }}</td>
                    <td>{{ i.document_type_name }}</td>
                    <td>
                      {{ i.printed_name }}
                      <small v-if="i.name_at_link && i.name_at_link !== i.printed_name" class="text-muted d-block">name at link: {{ i.name_at_link }}</small>
                    </td>
                    <td>{{ i.status }}</td>
                  </tr>
                </tbody>
              </table>
              <div v-else-if="certificates_error" class="text-danger">Failed to load certificates.</div>
              <div v-else class="text-muted">No certificates linked to this person.</div>
            </CCol>
        </CRow>
          <template #footer>
        <CButton @click="show = false" color="danger">Close</CButton>
      </template>
      <!-- <pre>{{ $data | json }}</pre> -->
    </CModal>
  </form>
</template>

<script>

import EventBus from '@/eventBus';
import people from '@/services/people'
import certificate from '@/services/certificate'

export default {
name: 'peoplemodal',

  data () {
    return {
      show: false,
      title: 'Default Title',
      mode: '',
      form:{
        id: '',
        firstname: '',
        lastname:'',
        email:'',
        phone :'',
        mobile_phone:'',
        address1:'',
        address2:'',
        city:'',
        state:'',
        country:'',
        zipcode:'',
        dob:'',
        sex:'',
        people_movement:[],
      },
      people_activity:[],
      certificates:[],
      certificates_loading: false,
      certificates_error: false,
      certificatesRequestId: 0,
      fields_movement:[
        {title: 'Tanggal', sortable: false, },
        {title: 'Keterangan', sortable: false},
      ],
    }
  },
   computed: {

   },
  mounted(){
    
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_SHOW_PEOPLE', (params) => {
      if(params.data){
        people.getPeoplebyID(params.data)
        .then(res => {
          self.show = true;
          self.title = params.title;
          self.mode = params.mode;
          self.form.uuid = params.data;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.email = res.data.email;
          self.form.phone = res.data.phone;
          self.form.mobile_phone = res.data.mobile_phone;
          self.form.address1 = res.data.address1;
          self.form.address2 = res.data.address2;
          self.form.city = res.data.city;
          self.form.state = res.data.state;
          self.form.country = res.data.country;
          self.form.zipcode = res.data.zipcode;
          self.form.dob = res.data.dob;
          self.form.sex = res.data.sex;
          self.form.people_movement = res.data.people_movement;
          self.people_activity = res.people_activity;
          self.loadCertificates(params.data);
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.firstname = "";
        self.form.lastname = "";
        self.form.email = "";
        self.form.phone = "";
        self.form.mobile_phone = "";
        self.form.address1 = "";
        self.form.address2 = "";
        self.form.city = "";
        self.form.state = "";
        self.form.country = "";
        self.form.zipcode = "";
        self.form.dob = "";
        self.form.sex = "";
        self.certificates = [];
      }
    });
  },

  methods: {
    loadCertificates (uuid) {
      this.certificates = [];
      this.certificates_error = false;
      this.certificates_loading = true;
      const requestId = ++this.certificatesRequestId;
      certificate.getPeopleCertificates(uuid, { per_page: 25 })
        .then(res => {
          if (requestId !== this.certificatesRequestId) return;
          this.certificates = (res.data && res.data.data) || [];
        })
        .catch(() => {
          if (requestId !== this.certificatesRequestId) return;
          this.certificates_error = true;
        })
        .finally(() => {
          if (requestId !== this.certificatesRequestId) return;
          this.certificates_loading = false;
        })
    },
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
  }
}
</script>
